import { createAxiosInstance, publicAxios } from 'common/utils/axios'

// Endpoint
import { USER_ENDPOINTS, USER_SERVICE_URL } from 'common/constants/apiUrls'

export const authAxiosLocalServer = createAxiosInstance(USER_SERVICE_URL)

const handler = authAxiosLocalServer

export const UpdatePassword = async ({ old_password, new_password }) => {
  const response = await handler.patch(USER_ENDPOINTS.UPDATE_USER_PASSWORD, {
    old_password,
    new_password,
  })

  const { data } = response.data

  return data
}
export const ResetPassword = async ({ email }) => {
  const response = await publicAxios.get(USER_ENDPOINTS.RESET_PASSWORD, { params: { email } })

  const { data } = response.data

  return data
}
export const ResetPasswordConfirm = async ({ password, token }) => {
  const response = await publicAxios.post(`${USER_ENDPOINTS.RESET_PASSWORD_CONFIRM}${token}`, { password })

  const { data } = response.data

  return data
}

// !FIND A BETTER WAY AROUND IT
export const GetUser = async ({ user_id }) => {
  // const customAuthAxios = createAxiosInstance(BASE_URL)
  const response = await authAxiosLocalServer.get(USER_ENDPOINTS.GET_USER + user_id)

  const { data } = response.data

  return data
}

export const SignupVasp = async ({ token, email, password, phone, name_first, name_last, timezone_code }) => {
  const response = await publicAxios.post(`${USER_ENDPOINTS.REGISTER}/${token}`, {
    token,
    email,
    password,
    phone,
    name_first,
    name_last,
    timezone_code,
  })

  const { data } = response.data

  return data
}
export const SignupTrial = async ({ email, password, name_first, name_last }) => {
  const response = await publicAxios.post(`${USER_ENDPOINTS.SIGNUP_TRIAL}`, {
    email,
    password,
    name_first,
    name_last,
  })

  const { data } = response.data

  return data
}

export const ConfirmTrialAccount = async ({ hash }) => {
  const response = await publicAxios.post(`${USER_ENDPOINTS.CONFIRMATION_TRIAL}/${hash}`)

  const { data } = response.data

  return data
}

export const GetVaspInfo = async (hash) => {
  const response = await publicAxios.get(`${USER_ENDPOINTS.VASP_INFO}/${hash}`)

  const { data } = response.data

  return data
}

export const ConfirmVaspEmail = async ({ hash }) => {
  const response = await publicAxios.post(`${USER_ENDPOINTS.CONFIRM_VASP_EMAIL}/${hash}`, {
    hash,
  })

  const { data } = response.data

  return data
}

export const ConfirmVaspUserEmail = async ({ hash }) => {
  const response = await publicAxios.post(`${USER_ENDPOINTS.CONFIRM_VASP_USER_EMAIL}/${hash}`, {
    hash,
  })

  const { data } = response.data

  return data
}

export const GetUserAuth = async ({ hash }) => {
  const response = await publicAxios.get(`${USER_ENDPOINTS.GET_USER_AUTH}${hash}`)

  const { data } = response.data

  return data
}
